import { render, staticRenderFns } from "./BarcodeTemplate.template.vue?vue&type=template&id=401d4701&scoped=true&"
var script = {}
import style0 from "./BarcodeTemplate.template.vue?vue&type=style&index=0&id=401d4701&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401d4701",
  null
  
)

export default component.exports